document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rp-carousel-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('[data-rp-track]');
    var prevBtn = wrap.querySelector('[data-rp-prev]');
    var nextBtn = wrap.querySelector('[data-rp-next]');
    if (!track) return;

    function scrollAmount() {
      var card = track.querySelector('.rp-card');
      if (!card) return 220;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.gap || '18', 10);
      return card.offsetWidth + gap;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });

  /* Wishlist hearts (uses same localStorage as product page) */
  document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
    var productId = btn.getAttribute('data-product-id');
    var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

    if (wishlist.indexOf(productId) !== -1) {
      btn.classList.add('is-active');
    }

    btn.addEventListener('click', function () {
      wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      var idx = wishlist.indexOf(productId);

      if (idx === -1) {
        wishlist.push(productId);
        btn.classList.add('is-active');
      } else {
        wishlist.splice(idx, 1);
        btn.classList.remove('is-active');
      }
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    });
  });
});